import { IMongoIndex } from '../../interfaces/mongo-index.interface';

export interface ICollectionList extends IMongoIndex {
    data: any;
}
